//const newLineRegex = /(\r\n|\r|\n)/g;
const newLineRegex = /(\n)/g;

export const nl2br = (text) => {
    if (text) {
      const html = text.replace(newLineRegex,'<br/>');
      /*
          text.split(newLineRegex)
            .reduce((accumulator, currentValue, currentIndex, array) => {
              return accumulator + "+++" + currentValue;
            });
      */          
      return html;  
    } else {
      return '';
    }
}

export const replacedoamin = (text) => {
  if(text) {
    const html = text.replace("%s", process.env["REACT_APP_SFC_DOMAIN"]);
console.log(html);
    return html;
  }
  else{
    return '';
  }
}

export const getBaseName = () => {

  const SFCSC = process.env['REACT_APP_SFCSC_DOMAIN'];

  let basename;
  if (window.location.hostname === SFCSC) {
    basename = `/TuniS/${process.env['REACT_APP_APPS_DOMAIN']}${process.env['PUBLIC_URL']}`;
  } else {
    basename = process.env['PUBLIC_URL'];
  }
  return basename;  
}

export const getSfcBaseName = () => {

  const SFCSC = process.env['REACT_APP_SFCSC_DOMAIN'];

  let basename;
  if (window.location.hostname === SFCSC) {
    basename = `/TuniS/${process.env['REACT_APP_SFC_DOMAIN']}`;
  } else {
    basename = process.env['REACT_APP_SFC_DOMAIN'];
  }
  return basename;  
 
}

export const getAlternateLanguageUrl = (lang) => {
  const appsDomain = process.env['REACT_APP_APPS_DOMAIN'];
  const pathname = window.location.pathname.replace(`/TuniS/${appsDomain}`, '').replace(/\/gateway\/(EN|TC)\//, `/gateway/${lang}/`);

  return `https://${appsDomain}${pathname}${window.location.search}`;
}

export const getSimplifiedChineseUrl = () => {
  const appsDomain = process.env['REACT_APP_APPS_DOMAIN'];
  const sfcscDomain = process.env['REACT_APP_SFCSC_DOMAIN'];
  const pathname = window.location.pathname.replace(`/TuniS/${appsDomain}`, '').replace(/\/gateway\/(EN|TC)\//, '/gateway/TC/');

  return `https://${sfcscDomain}/TuniS/${appsDomain}${pathname}${window.location.search}`;
}

export const getAlternateLanguageLinks = () => {
  return [
    {
      hrefLang: 'en',
      href: getAlternateLanguageUrl('EN')
    },
    {
      hrefLang: 'zh-Hant',
      href: getAlternateLanguageUrl('TC')
    },
    {
      hrefLang: 'zh-Hans',
      href: getSimplifiedChineseUrl()
    }
  ];
}